// Geradores de URL de busca de contato pessoal por sócio.
// Não grava nada — só abre a busca pro Nikolai confirmar e colar (LGPD-safe).

/** Google com nome entre aspas + cidade pra desambiguar. */
export function googleSearch(nome: string, cidade?: string): string {
  const q = cidade ? `"${nome}" ${cidade}` : `"${nome}"`;
  return 'https://www.google.com/search?q=' + encodeURIComponent(q);
}

/** Instagram via Google site-search (a busca nativa do IG exige login). */
export function instagramSearch(nome: string): string {
  return 'https://www.google.com/search?q=' + encodeURIComponent(`"${nome}" site:instagram.com`);
}

/** wa.me com DDI 55. Retorna null se não houver dígitos suficientes. */
export function whatsappLink(telefone: string): string | null {
  const d = (telefone || '').replace(/\D/g, '');
  if (d.length < 10) return null;
  const withCountry = d.startsWith('55') ? d : `55${d}`;
  return `https://wa.me/${withCountry}`;
}
